
import { ChevronDown } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  isHomepage?: boolean;
}

const HeroSection = ({
  title,
  subtitle,
  backgroundImage = '/images/hero-bg.jpg',
  isHomepage = false,
}: HeroSectionProps) => {
  const scrollToContent = () => {
    const contentSection = document.getElementById('content');
    if (contentSection) {
      contentSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`relative w-full ${isHomepage ? 'min-h-screen' : 'min-h-[60vh]'} flex items-center justify-center overflow-hidden`}
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(42, 37, 34, 0.7), rgba(42, 37, 34, 0.8)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Grain texture overlay */}
      <div className="absolute inset-0 bg-texture opacity-20 mix-blend-overlay"></div>
      
      {/* Content */}
      <div className="container-custom relative z-10 text-center max-w-4xl mx-auto px-4 pt-24">
        <h1 className="heading-xl text-white text-shadow animate-fade-in">
          {title}
        </h1>
        
        {subtitle && (
          <p className="mt-6 text-lg md:text-xl text-white/80 max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: '200ms' }}>
            {subtitle}
          </p>
        )}
        
        {isHomepage && (
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in" style={{ animationDelay: '400ms' }}>
            <NavLink to="/ride-hub" className="btn-primary">
              Find a Ride
            </NavLink>
            <NavLink to="/rallies" className="btn-primary">
              Join a Rally
            </NavLink>
          </div>
        )}
      </div>
      
      {/* Scroll indicator */}
      {isHomepage && (
        <button
          onClick={scrollToContent}
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/70 hover:text-white transition-colors animate-bounce"
          aria-label="Scroll down"
        >
          <ChevronDown size={32} />
        </button>
      )}
    </div>
  );
};

export default HeroSection;
